<template>
  <div class="application">
    <transition name="fade">
      <intro-section
        v-if="step == 1"
        title="Soft Underwriting"
        body="Soft Underwriting text"
        btn_text="Get Started"
        icon="high5"
        v-on:next="next(2)"
      ></intro-section>
    </transition>

    <template>
      <transition name="fade">
        <div class="questions" v-if="step > 1">
          <questions
            :step="step"
            question_title="start"
            :questions="questions"
            v-on:saveAnswer="saveAnswer"
          ></questions>
        </div>
      </transition>
    </template>

    <transition name="fade">
      <saving-info
        v-if="save_info_screen"
        title="Analyzing Soft Underwriting"
        body="Soft Underwriting text"
      ></saving-info>
    </transition>
  </div>
</template>

<script>
import { db, functions, auth } from "@/config/firebaseInit";
import firebase from "firebase";
import Section from "@/components/Application/Section";
import Questions from "@/components/Application/Questions";
import QuestionsList from "@/components/Application/Forms.json";
import SavingInfo from "@/components/Application/SavingInfo";

export default {
  name: "SoftUnderwriting",
  components: {
    "intro-section": Section,
    questions: Questions,
    "saving-info": SavingInfo
  },
  data() {
    return {
      answers: {},
      save_info_screen: false,
      step: this.$store.state.application_approval_step,
      previous_step: 2,
      questions: QuestionsList["soft_underwriting"],
    };
  },
  created() {
    let questions = 0;
    for (var key in QuestionsList) {
      questions += QuestionsList[key].length;
    }
  },
  methods: {
    next(step) {
      this.step = null;
      setTimeout(() => {
        this.step = step;
      }, 500);
    },
    saveAnswer(name, answer) {
      this.answers[name] = answer;
      this.$store.commit(
        "setProgress",
        Math.floor(((this.step - 1) / this.questions.length) * 100)
      );
      if (answer.length) this.$store.commit("setAnswers", this.answers);
    },
    saveData() {
      this.save_info_screen = true;
      let data = {
        answers: this.$store.state.answers,
        created_at: Date.now(),
        status: "review",
        phase: "Soft Underwriting"
      };
      this.$store.commit("setUser", data);
      let ref = db
        .collection("user")
        .doc(this.$store.state.user_id)
        .collection("soft_underwriting");
      let id = ref.doc().id;
      this.$store.commit("setTempId", id);
      ref
        .doc(id)
        .set(data, { merge: true })
        .then(doc => {
          setTimeout(() => {
            this.$parent.step = null;
            setTimeout(() => {
              this.$parent.step = "review";
            }, 500);
          }, 7000);
        });
    }
  }
};
</script>

<style lang="scss">
.intro {
  height: auto;
  min-height: 100vh;
  background: rgba(11, 110, 251, 0.08);
  width: 100%;
  text-align: center;
  .contain {
    display: flex;
    justify-content: center;
    flex-direction: column;
    min-height: 100vh;
    max-width: 700px;
    .icon {
      height: 70px;
      margin-bottom: 30px;
    }
    h1 {
      font-size: 50px;
    }
  }
}

.questions {
  max-width: 450px;
  width: 100%;
  margin: auto;
  margin-top: 30px;
}
</style>
